import { render, staticRenderFns } from "./ApplicationSectionForDiscussionLpType.vue?vue&type=template&id=d33bc3f6&scoped=true&"
import script from "./ApplicationSectionForDiscussionLpType.vue?vue&type=script&lang=js&"
export * from "./ApplicationSectionForDiscussionLpType.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSectionForDiscussionLpType.vue?vue&type=style&index=0&id=d33bc3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33bc3f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
